import React from 'react';

import PropTypes from 'prop-types';

import * as S from './styles';

export default function ModalFilter({ inputs, formatter }) {
  return (
    <S.Wrapper>
      {inputs.map(({ id, type, label, options, autocomplete, ...filter }) =>
        formatter(id, type, label, options, false, autocomplete, filter)
      )}
    </S.Wrapper>
  );
}

ModalFilter.propTypes = {
  inputs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      label: PropTypes.string,
      options: PropTypes.arrayOf(PropTypes.any),
      minDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
        PropTypes.object,
        PropTypes.func,
      ]),
      maxDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
        PropTypes.object,
        PropTypes.func,
      ]),
      shouldDisableDate: PropTypes.func,
      disableMaskedInput: PropTypes.bool,
      helperText: PropTypes.string,
    })
  ).isRequired,
  formatter: PropTypes.func.isRequired,
};
